export default __webpack_public_path__ + "d1dbb3ad7d78c1bf14a0c1102cf5d800.jpg";